






import { defineComponent } from '@vue/composition-api';
import CommonFormWithVehicleEditor from '@/components/Setting/CommonFormWithVehicleEditor.vue';

const DriverInformation = defineComponent({
  components: {
    CommonFormWithVehicleEditor,
  },
  // setup() {},
});

export default DriverInformation;
